import React from 'react';

const LoadingSpinner = ({ size = 'medium', className = '' }) => {
  // تعريف الأحجام مع ضبط السماكة والظلال بشكل احترافي
  const sizeClasses = {
    small: {
      container: 'w-6 h-6',
      spinner: 'w-4 h-4 border-2',
      glow: 'w-3 h-3 blur-md'
    },
    medium: {
      container: 'w-12 h-12',
      spinner: 'w-8 h-8 border-[3px]',
      glow: 'w-6 h-6 blur-lg'
    },
    large: {
      container: 'w-20 h-20',
      spinner: 'w-14 h-14 border-4',
      glow: 'w-10 h-10 blur-xl'
    },
  };

  const selectedSize = sizeClasses[size] || sizeClasses.medium;

  return (
    <div className={`relative flex items-center justify-center ${selectedSize.container} ${className}`}>
      
      {/* 1. تأثير النبض الخلفي (Glow Pulse) */}
      <div className={`
        absolute 
        ${selectedSize.glow} 
        bg-primary-500/30 
        rounded-full 
        animate-pulse
      `} />

      {/* 2. الحلقة الخلفية الثابتة (Track Ring) */}
      <div className={`
        absolute 
        ${selectedSize.spinner} 
        border-gray-100 
        dark:border-gray-800 
        rounded-full
      `} />

      {/* 3. المؤشر الدوار الأساسي (Main Gradient Spinner) */}
      <div
        className={`
          ${selectedSize.spinner}
          animate-spin
          rounded-full
          border-transparent
          border-t-primary-600
          border-r-primary-400
          dark:border-t-primary-500
          dark:border-r-primary-300
          shadow-sm
        `}
        style={{
          boxShadow: '0 0 15px -5px rgba(var(--color-primary-600), 0.2)'
        }}
      />

      {/* 4. لمسة جمالية (Center Dot) - تظهر فقط في الحجم المتوسط والكبير */}
      {size !== 'small' && (
        <div className="absolute w-1.5 h-1.5 bg-primary-600/20 rounded-full animate-ping" />
      )}
      
    </div>
  );
};

export default LoadingSpinner;